export default __webpack_public_path__ + "bfx/static/media/back.6a6556d9.svg";